import { simpleSet } from '@r/reducers/utils';

const setCameraPerItem = simpleSet as redux.reducers.flags.cameraPerItem;
export const cameraPerItem = setCameraPerItem(
  'SET_CAMERA_PER_ITEM',
  false
);
